import type { ReactNode } from 'react'
import { useTranslation } from 'next-i18next'
import { twMerge } from 'tailwind-merge'
import { featureFlagsClient } from 'shared/feature-flags/client'
import { featureFlagKeys } from 'shared/feature-flags/feature-keys'
import { isWorkspaceMember } from 'shared/hooks/use-user'
import type { UnauthorizedUser, UserInterface } from 'shared/types/user-interface'

type UnderModerationContentType = 'comment' | 'post'

interface UnderModerationPlaceholderProps {
  type: UnderModerationContentType
  className?: string
}

const TRANSLATION_KEY_BY_TYPE = {
  post: 'community.moderation.content.post_hidden',
  comment: 'community.moderation.content.comment_hidden',
} as const satisfies Record<UnderModerationContentType, string>

export const shouldHideUnderModerationContent = (
  underModeration: boolean | undefined,
  user: UnauthorizedUser | UserInterface | undefined,
): boolean => {
  if (!featureFlagsClient.isOn(featureFlagKeys.enableCommunityReports) || !underModeration) {
    return false
  }
  if (!user) return true
  return !isWorkspaceMember(user)
}

export const UnderModerationPlaceholder = ({
  type,
  className,
}: UnderModerationPlaceholderProps): ReactNode => {
  const { t } = useTranslation()

  return (
    <p className={twMerge('text-base text-text-secondary', className)}>
      {t(TRANSLATION_KEY_BY_TYPE[type])}
    </p>
  )
}
